import {VERIFY_FORM_CHANGE} from '../../constants';
export const verifyFormChange = event => {
    return {
        type: VERIFY_FORM_CHANGE,
        payload: event
    };
};
